import { DashedTitle, Icon, InfoTooltip } from '@fasstech/middle-design-system';

const ClosedComponent = ({ children, titleLabel, icon, informations }) => {
  return (
    <div className="flex flex-col gap-2 p-4">
      <div className="flex flex-col items-center gap-2">
        <Icon name={icon} size={20} />
        <DashedTitle>
          <span className="flex items-center gap-2">
            {titleLabel}
            {informations && <InfoTooltip text={informations} />}
          </span>
        </DashedTitle>
      </div>
      {children}
    </div>
  );
};

export default ClosedComponent;
